/* eslint-disable no-negated-condition */
/* eslint-disable keyword-spacing */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// import ScratchBlocks from 'openblock-blocks'; // Không cần thiết nữa vì đã bỏ hệ thống translation

import {eventBlock} from './libraries/devices/index.jsx';

const categorySeparator = '<sep gap="36"/>';

const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px

/* eslint-disable no-unused-vars */
const motion = function (isInitialSetup, isStage, targetId) {
    const stageSelected = 'Đã chọn nền: không có khối lập trình chuyển động';
    return `
    <category name="Chuyển động" id="motion" colour="#4C97FF" secondaryColour="#3373CC">
        ${isStage ? `
        <label text="${stageSelected}"></label>
        ` : `
        <block type="motion_movesteps">
            <value name="STEPS">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnright">
            <value name="DEGREES">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnleft">
            <value name="DEGREES">
                <shadow type="math_number">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_goto">
            <value name="TO">
                <shadow type="motion_goto_menu">
                </shadow>
            </value>
        </block>
        <block type="motion_gotoxy">
            <value name="X">
                <shadow id="movex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="movey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_glideto" id="motion_glideto">
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="motion_glideto_menu">
                </shadow>
            </value>
        </block>
        <block type="motion_glidesecstoxy">
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="X">
                <shadow id="glidex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="glidey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_pointindirection">
            <value name="DIRECTION">
                <shadow type="math_angle">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
        <block type="motion_pointtowards">
            <value name="TOWARDS">
                <shadow type="motion_pointtowards_menu">
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_changexby">
            <value name="DX">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_setx">
            <value name="X">
                <shadow id="setx" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_changeyby">
            <value name="DY">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_sety">
            <value name="Y">
                <shadow id="sety" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_ifonedgebounce"/>
        ${blockSeparator}
        <block type="motion_setrotationstyle"/>
        ${blockSeparator}
        <block id="${targetId}_xposition" type="motion_xposition"/>
        <block id="${targetId}_yposition" type="motion_yposition"/>
        <block id="${targetId}_direction" type="motion_direction"/>`}
        ${categorySeparator}
    </category>
    `;
};

const xmlEscape = function (unsafe) {
    return unsafe.replace(/[<>&'"]/g, c => {
        switch (c) {
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '&': return '&amp;';
        case '\'': return '&apos;';
        case '"': return '&quot;';
        }
    });
};

const looks = function (isInitialSetup, isStage, targetId, costumeName, backdropName) {
    const hello = 'Xin chào!';
    const hmm = 'Hmm...';
    return `
    <category name="Hình dạng" id="looks" colour="#9966FF" secondaryColour="#774DCB">
        ${isStage ? '' : `
        <block type="looks_sayforsecs">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_say">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
        </block>
        <block type="looks_thinkforsecs">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_think">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        `}
        ${isStage ? `
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_switchbackdroptoandwait">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
        ` : `
            <block id="${targetId}_switchcostumeto" type="looks_switchcostumeto">
                <value name="COSTUME">
                    <shadow type="looks_costume">
                        <field name="COSTUME">${costumeName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextcostume"/>
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
            ${blockSeparator}
            <block type="looks_changesizeby">
                <value name="CHANGE">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_setsizeto">
                <value name="SIZE">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>
        `}
        ${blockSeparator}
        <block type="looks_changeeffectby">
            <value name="CHANGE">
                <shadow type="math_number">
                    <field name="NUM">25</field>
                </shadow>
            </value>
        </block>
        <block type="looks_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="looks_cleargraphiceffects"/>
        ${blockSeparator}
        ${isStage ? '' : `
            <block type="looks_show"/>
            <block type="looks_hide"/>
        ${blockSeparator}
            <block type="looks_gotofrontback"/>
            <block type="looks_goforwardbackwardlayers">
                <value name="NUM">
                    <shadow type="math_integer">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
            </block>
        `}
        ${isStage ? `
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
        ` : `
            <block id="${targetId}_costumenumbername" type="looks_costumenumbername"/>
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
            <block id="${targetId}_size" type="looks_size"/>
        `}
        ${categorySeparator}
    </category>
    `;
};

const sound = function (isInitialSetup, isStage, targetId, soundName) {
    return `
    <category name="Âm thanh" id="sound" colour="#D65CD6" secondaryColour="#BD42BD">
        <block id="${targetId}_sound_playuntildone" type="sound_playuntildone">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_sound_play" type="sound_play">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block type="sound_stopallsounds"/>
        ${blockSeparator}
        <block type="sound_changeeffectby">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block type="sound_cleareffects"/>
        ${blockSeparator}
        <block type="sound_changevolumeby">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">-10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_setvolumeto">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_volume" type="sound_volume"/>
        ${categorySeparator}
    </category>
    `;
};

const events = function (isInitialSetup, isStage) {
    return `
    <category name="Sự kiện" id="events" colour="#FFD500" secondaryColour="#CC9900">
        <block type="event_whenflagclicked"/>
        <block type="event_whenkeypressed">
        </block>
        ${isStage ? `
            <block type="event_whenstageclicked"/>
        ` : `
            <block type="event_whenthisspriteclicked"/>
        `}
        <block type="event_whenbackdropswitchesto">
        </block>
        ${blockSeparator}
        <block type="event_whengreaterthan">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="event_whenbroadcastreceived">
        </block>
        <block type="event_broadcast">
            <value name="BROADCAST_INPUT">
                <shadow type="event_broadcast_menu"></shadow>
            </value>
        </block>
        <block type="event_broadcastandwait">
            <value name="BROADCAST_INPUT">
              <shadow type="event_broadcast_menu"></shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const control = function (isInitialSetup, isStage, targetId, isRealtimeMode) {
    return `
    <category name="Điều khiển" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
        <block type="control_wait">
            <value name="DURATION">
                <shadow type="math_positive_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="control_repeat">
            <value name="TIMES">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block id="forever" type="control_forever"/>
        ${blockSeparator}
        <block type="control_if"/>
        <block type="control_if_else"/>
        <block id="wait_until" type="control_wait_until"/>
        <block id="repeat_until" type="control_repeat_until"/>
        ${blockSeparator}
        ${isRealtimeMode ? `
            <block type="control_stop"/>
            ${blockSeparator}
            ${isStage ? `
                <block type="control_create_clone_of">
                    <value name="CLONE_OPTION">
                        <shadow type="control_create_clone_of_menu"/>
                    </value>
                </block>
            ` : `
                <block type="control_start_as_clone"/>
                <block type="control_create_clone_of">
                    <value name="CLONE_OPTION">
                        <shadow type="control_create_clone_of_menu"/>
                    </value>
                </block>
                <block type="control_delete_this_clone"/>
            `}
            ${categorySeparator}
        ` : null}
    </category>
    `;
};

const sensing = function (isInitialSetup, isStage) {
    const name = 'Tên của bạn là gì?';
    return `
    <category name="Cảm biến" id="sensing" colour="#4CBFE6" secondaryColour="#2E8EB8">
        ${isStage ? '' : `
            <block type="sensing_touchingobject">
                <value name="TOUCHINGOBJECTMENU">
                    <shadow type="sensing_touchingobjectmenu"/>
                </value>
            </block>
            <block type="sensing_touchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_coloristouchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
                <value name="COLOR2">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_distanceto">
                <value name="DISTANCETOMENU">
                    <shadow type="sensing_distancetomenu"/>
                </value>
            </block>
            ${blockSeparator}
        `}
        ${isInitialSetup ? '' : `
            <block id="askandwait" type="sensing_askandwait">
                <value name="QUESTION">
                    <shadow type="text">
                        <field name="TEXT">${name}</field>
                    </shadow>
                </value>
            </block>
        `}
        <block id="answer" type="sensing_answer"/>
        ${blockSeparator}
        <block type="sensing_keypressed">
            <value name="KEY_OPTION">
                <shadow type="sensing_keyoptions"/>
            </value>
        </block>
        <block type="sensing_mousedown"/>
        <block type="sensing_mousex"/>
        <block type="sensing_mousey"/>
        ${isStage ? '' : `
            ${blockSeparator}
            '<block type="sensing_setdragmode" id="sensing_setdragmode"></block>'+
            ${blockSeparator}
        `}
        ${blockSeparator}
        <block id="loudness" type="sensing_loudness"/>
        ${blockSeparator}
        <block id="timer" type="sensing_timer"/>
        <block type="sensing_resettimer"/>
        ${blockSeparator}
        <block id="of" type="sensing_of">
            <value name="OBJECT">
                <shadow id="sensing_of_object_menu" type="sensing_of_object_menu"/>
            </value>
        </block>
        ${blockSeparator}
        <block id="current" type="sensing_current"/>
        <block type="sensing_dayssince2000"/>
        ${blockSeparator}
        <block type="sensing_username"/>
        ${categorySeparator}
    </category>
    `;
};

const operators = function (isInitialSetup) {
    const apple = 'táo';
    const banana = 'chuối';
    const letter = 't';
    return `
    <category name="Toán học" id="operators" colour="#40BF4A" secondaryColour="#389438">
        <block type="operator_add">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_subtract">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_multiply">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_divide">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_random">
            <value name="FROM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_gt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_lt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_equals">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_and"/>
        <block type="operator_or"/>
        <block type="operator_not"/>
        ${blockSeparator}
        ${isInitialSetup ? '' : `
            <block type="operator_join">
                <value name="STRING1">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
                <value name="STRING2">
                    <shadow type="text">
                        <field name="TEXT">${banana}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_letter_of">
                <value name="LETTER">
                    <shadow type="math_whole_number">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
                <value name="STRING">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_length">
                <value name="STRING">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_contains" id="operator_contains">
              <value name="STRING1">
                <shadow type="text">
                  <field name="TEXT">${apple}</field>
                </shadow>
              </value>
              <value name="STRING2">
                <shadow type="text">
                  <field name="TEXT">${letter}</field>
                </shadow>
              </value>
            </block>
        `}
        ${blockSeparator}
        <block type="operator_mod">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_round">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_mathop">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const variables = function () {
    return `
    <category
        name="Biến số"
        id="variables"
        colour="#FF8C1A"
        secondaryColour="#DB6E00"
        custom="VARIABLE">
    </category>
    `;
};

const myBlocks = function () {
    return `
    <category
        name="Khối của tôi"
        id="myBlocks"
        colour="#FF6680"
        secondaryColour="#FF4D6A"
        custom="PROCEDURE">
    </category>
    `;
};

const demo = function (isInitialSetup, isStage, targetId) {
    return `
    <category name="Demo" id="demo" colour="#9B59B6" secondaryColour="#8E44AD">
        <block type="demo_hello" colour="#9B59B6">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">Hello from Demo!</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="demo_led_on" colour="#9B59B6"/>
        <block type="demo_led_off" colour="#9B59B6"/>
        <block type="demo_delay" colour="#9B59B6">
            <value name="DELAY">
                <shadow type="math_number">
                    <field name="NUM">1000</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="demo_clear_screen" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
};

const manHinh = function (isInitialSetup, isStage, targetId) {
    // Use your custom SVG as data URI
    const svgContent = `<?xml version="1.0" encoding="utf-8"?>
<svg width="24" height="24" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
  <g id="mac">
    <path d="M2,13" fill="#1a2f4b"/>
    <path d="M3,38.824" fill="#0278ae"/>
    <g>
      <path d="M2.583,37.8l58.24-.139.055-25.131-.912-.905-56.858.255" fill="#1a2f4b"/>
      <path d="M3.046,37.632l.157,5.1.775.808,55.749.009.819-.464L61,40.029v-2.7l-.345.755L3.5,37.8" fill="#51dacf"/>
      <path d="M29,44v5.324l-5.172-.315-1.392.487-.07,1.949.975.418,3.272.209,13.776-.2.983-.427.446-1-.794-1.161L39,49H35l.3-6H29" fill="#51dacf"/>
      <path d="M29,43h6l.384,2H29l-.3-1.695" fill="#47aed6"/>
      <path d="M22,50.338l20-.014-.938,1.253-.393.393L23.2,51.849" fill="#76f4e8"/>
      <path d="M60.779,38.768,2.878,38.7l.205-.9,57.767.047" fill="#76f4e8"/>
      <line y2="20" transform="translate(58.5 15)" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="1" opacity="0.5"/>
      <line y2="20" transform="translate(56.5 15)" fill="none" stroke="#ffffff" stroke-miterlimit="10" stroke-width="1" opacity="0.5"/>
      <rect width="58.046" height="31.778" rx="1.291" transform="translate(2.977 11.789)" fill="none" stroke="#1a2f4b" stroke-miterlimit="10" stroke-width="1"/>
      <line y1="0.004" x2="58.663" transform="translate(2.669 37.824)" fill="none" stroke="#1a2f4b" stroke-width="0.75"/>
      <g>
        <path d="M35.3,49.014v-5.38H28.7v5.38H23.61a1.43,1.43,0,0,0,0,2.86H40.39a1.43,1.43,0,1,0,0-2.86Z" fill="none" stroke="#1a2f4b" stroke-miterlimit="10" stroke-width="1"/>
      </g>
      <circle cx="1.193" cy="1.193" r="1.193" transform="translate(30.807 39.352)" fill="none" stroke="#76f4e8" stroke-miterlimit="10" stroke-width="0.75"/>
    </g>
  </g>
</svg>`;
    const screenIcon = `data:image/svg+xml;base64,${btoa(svgContent)}`;
    return `
    <category name="Màn hình" id="man_hinh" colour="#FF6B35" secondaryColour="#E55A2B" iconURI="${screenIcon}">
        <block type="demo_OLED_start" colour="#9B59B6"/>
        <block type="demo_robot_emotion" colour="#9B59B6"/>
        <block type="demo_robot_oled_display" colour="#9B59B6">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">TEXT</field>
                </shadow>
            </value>
            <value name="POS_X">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="POS_Y">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="TEXT_SIZE">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="oled_text" colour="#9B59B6">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">TEXT</field>
                </shadow>
            </value>
            <value name="POS_X">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="POS_Y">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="TEXT_SIZE">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="oled_number" colour="#9B59B6">
            <value name="MESSAGE">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="POS_X">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="POS_Y">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="TEXT_SIZE">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const Dongco = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const motorIconPath = 'static/assets/Dongco.svg';
    return `
    <category name="Động cơ" id="dong_co" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${motorIconPath}">
        <block type="demo_motor_start" colour="#1B263B"/>
        <block type="motor_custom" colour="#1B263B"/>
        <block type="demo_robot_forward" colour="#1B263B"/>
        <block type="demo_robot_back" colour="#1B263B"/>
        <block type="demo_robot_turn_right" colour="#1B263B"/>
        <block type="demo_robot_turn_left" colour="#1B263B"/>
        <block type="demo_robot_stop" colour="#1B263B"/>
        ${categorySeparator}
    </category>
    `;
};

const Cambienrung = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Cambienrungchan.svg';
    return `
    <category name="Cảm biến rung" id="cam_bien_rung" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="vibration_start" colour="#9B59B6"/>
        <block type="vibration_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
};

const Cambienanhsang = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Cambienanhsang.svg';
    return `
    <category name="Cảm biến ánh sáng" id="cam_bien_anh_sang" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="solar_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="solar_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
};

const Cambienvatcan = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Cambienvatcan.svg';
    return `
    <category name="Cảm biến vật cản" id="cam_bien_vat_can" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="Irsensor_block" colour="#d69429ff"/>
        <block type="detect_object" colour="#d69429ff"/>
        ${categorySeparator}
    </category>
    `;
};

const Cambienhongngoai = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Cambienhongngoai.svg';
    return `
    <category name="Cảm biến hồng ngoại" id="cam_bien_hong_ngoai" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="infrared_sensor_start" colour="#2563EB"/>
        ${blockSeparator}
        <block type="infrared_sensor_button" colour="#2563EB"/>
        ${blockSeparator}
        <block type="infrared_sensor_test" colour="#2563EB"/>
        ${categorySeparator}
    </category>
    `;
};

const Matkhau = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/password.svg';
    return `
    <category name="Mật khẩu" id="mat_khau" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="password_setup" colour="#05a2b0ff">
            <value name="pass1">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="pass2">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="pass3">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="pass4">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="progress_password" colour="#05a2b0ff"/>
        ${blockSeparator}
        <block type="password_true" colour="#05a2b0ff"/>
        <block type="password_wrong" colour="#05a2b0ff"/>
        ${blockSeparator}
        <block type="password_done" colour="#05a2b0ff"/>
        ${categorySeparator}
    </category>
    `;
};

const Thoigian = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/timer.svg';
    return `
    <category name="Thời gian" id="thoi_gian" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="timer_setup" colour="#f0ff22ff"/>
        ${blockSeparator}
        <block type="timer_limit" colour="#f0ff22ff">
            <value name="time">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="timer_value" colour="#f0ff22ff">
            <value name="time">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const Nutnhan = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Nutnhan.svg';
    return `
    <category name="Nút nhấn" id="nut_nhan" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="button_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="left_button_value" colour="#9B59B6">
            <value name="button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="right_button_value" colour="#9B59B6">
            <value name="button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="setting_toggle_button" colour="#9B59B6">
            <value name="right_button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="left_button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const Coichip = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Coichip.svg';
    return `
    <category name="Còi chip" id="coi_chip" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="demo_buzzer_start" colour="#9B59B6"/>
        <block type="demo_buzzer_alarm" colour="#9B59B6"/>
        <block type="demo_warining_danger" colour="#9B59B6"/>
        <block type="demo_turn_off_buzzer" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
};

const Bluetooth = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Bluetooth.svg';
    return `
    <category name="Bluetooth" id="bluetooth" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="bluetooth_start" colour="#00ACC1"/>
        <block type="bluetooth_test" colour="#00ACC1"/>
        <block type="signal_from" colour="#00ACC1"/>
        <block type="send_text" colour="#00ACC1">
            <value name="message">
                <shadow type="text">
                    <field name="TEXT">Text</field>
                </shadow>
            </value>
        </block>
        <block type="dimmer_value" colour="#00ACC1"/>
        <block type="sinal_from_gamepad" colour="#00ACC1">
            <value name="gamepad_value">
                <shadow type="text">
                    <field name="TEXT">Text</field>
                </shadow>
            </value>
        </block>
        <block type="signal_from_void_controll" colour="#00ACC1">
            <value name="void_controll_value">
                <shadow type="text">
                    <field name="TEXT">Text</field>
                </shadow>
            </value>
        </block>
        <block type="color_picker_value" colour="#00ACC1"/>
        <block type="signal_from_terminal" colour="#00ACC1">
            <value name="Terminal_value">
                <shadow type="text">
                    <field name="TEXT">Text</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const Duanmau = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Duanmau.svg';
    return `
    <category name="Dự án mẫu" id="du_an_mau" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="example_star_war" colour="#9B59B6"/>
        <block type="example_soccer_player" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
};

const led = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/led.svg';
    return `
    <category name="Đèn led" id="led" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="led_start" colour="#9B59B6"/>
        <block type="led_mode_on_pin" colour="#9B59B6"/>
        <block type="led_on_effect" colour="#9B59B6">
            <value name="time">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="led_off_effect" colour="#9B59B6">
            <value name="time">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="led_on_intensity" colour="#9B59B6">
            <value name="intensity">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const Esp32_Test_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/circuit_board.svg';
    return `
    <category name="ESP32 Test Blocks" id="esp32_test_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_test_adc" colour="#9B59B6"/>
        <block type="esp32_test_i2c" colour="#9B59B6"/>
        <block type="esp32_test_blocks" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_RGB_Sensor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Cambienmausac.svg';
    return `
    <category name="Cảm biến màu sắc" id="esp32_rgb_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_rgb_sensor_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_rgb_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_color_check" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_rgb_color_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_rgb_read_color_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_Motion_Sensor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Cambienchuyendong.svg';
    return `
    <category name="Cảm biến chuyển động" id="esp32_motion_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_SR602_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_SR602_check" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_VL6180X_Sensor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Cambienhongngoaikhoangcach.svg';
    return `
    <category name="Cảm biến lazer khoảng cách" id="esp32_vl6180x_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_VL6180X_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_VL6180X_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_VL6180X_read_distance_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_TCRT5000_Sensor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Cambiendoline.svg';
    return `
    <category name="Cảm biến dò line" id="esp32_tcrt5000_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_TCRT5000_start" colour="#9B59B6">
            <value name="value">
                <shadow type="math_number">
                    <field name="NUM">2500</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_TCRT5000_check" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_HW484_Sensor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Fire.svg';
    return `
    <category name="Cảm biến phát hiện lửa" id="esp32_hw484_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_HW484_start" colour="#9B59B6">
            <value name="value">
                <shadow type="math_number">
                    <field name="NUM">2000</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_HW484_check" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_MQ2_Smoke_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Smoke.svg';
    return `
    <category name="Cảm biến khói" id="esp32_mq2_smoke_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_MQ2_Smoke_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_MQ2_Smoke_check" colour="#9B59B6"/>
        ${blockSeparator}
        ${categorySeparator}
    </category>
    `;
}

const Esp32_BME680_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Cambiennhietdodoam.svg';
    return `
    <category name="Cảm biến nhiệt độ , độ ẩm" id="esp32_bme680_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_BME680_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_BME680_temperature_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_BME680_humidity_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_BME680_pressure_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_BME680_air_value" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_BME680_read_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_WB2812_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/EspLed.svg';
    return `
    <category name="Đèn led WB2812" id="esp32_wb2812_led_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_WB2812_Led_start" colour="#9B59B6">
            <value name="value">
                <shadow type="math_number">
                    <field name="NUM">72</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_WB2812_set_color" colour="#9B59B6">
            <value name="position">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="red">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="green">
                <shadow type="math_number">
                    <field name="NUM">255</field>
                </shadow>
            </value>
            <value name="blue">
                <shadow type="math_number">
                    <field name="NUM">255</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_WB2812_effect" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

const Esp32_Oled_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/screen.svg';
    return `
    <category name="Màn hình OLED" id="esp32_oled_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_Oled_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_Oled_display" colour="#9B59B6"/>
        ${blockSeparator}
        ${categorySeparator}
    </category>
    `;
}

const Esp32_Servo_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/servo.svg';
    return `
    <category name="Động cơ Servo" id="esp32_servo_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_Servo_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_Servo_set_angle" colour="#9B59B6">
            <value name="angle">
                <shadow type="math_number">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        ${categorySeparator}
    </category>
    `;
}

const Esp32_Motor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Dongco.svg';
    return `
    <category name="Động cơ" id="esp32_motor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_Motor_Start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_motor_custom" colour="#9B59B6">
            <value name="speed">
                <shadow type="math_number">
                    <field name="NUM">150</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_motor_forward" colour="#9B59B6">
            <value name="speed">
                <shadow type="math_number">
                    <field name="NUM">150</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_motor_back" colour="#9B59B6">
            <value name="speed">
                <shadow type="math_number">
                    <field name="NUM">150</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_motor_turn_right" colour="#9B59B6">
            <value name="speed">
                <shadow type="math_number">
                    <field name="NUM">150</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_motor_turn_left" colour="#9B59B6">
            <value name="speed">
                <shadow type="math_number">
                    <field name="NUM">150</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_motor_stop" colour="#9B59B6"/>
        ${blockSeparator}
        ${categorySeparator}
    </category>
    `;
}

const Esp32_Button_Blocks = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/Nutnhan.svg';
    return `
    <category name="Nút nhấn" id="nut_nhan" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_button_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_left_button_value" colour="#9B59B6">
            <value name="button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_right_button_value" colour="#9B59B6">
            <value name="button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_setting_toggle_button" colour="#9B59B6">
            <value name="right_button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="left_button_value">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const Esp32_Led = function (isInitialSetup, isStage, targetId) {
    // Use your original SVG asset to avoid any visual differences or clipping
    const IconPath = 'static/assets/led.svg';
    return `
    <category name="Đèn led" id="esp32_led" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_led_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_led_mode_on_pin" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_led_on_effect" colour="#9B59B6">
            <value name="time">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_led_off_effect" colour="#9B59B6">
            <value name="time">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_led_on_intensity" colour="#9B59B6">
            <value name="intensity">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        ${categorySeparator}
    </category>
    `;
};

// esp32_Wifi_Blocks
const esp32_Wifi_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/wifi.svg';
    return `
    <category name="Wifi" id="esp32_wifi_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_wifi" colour="#9B59B6">
            <value name="ssid">
                <shadow type="text">
                    <field name="TEXT">ESP32-Web</field>
                </shadow>
            </value>
            <value name="password">
                <shadow type="text">
                    <field name="TEXT">12345678</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esp32_button_clicked" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_wifi_input" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

// esp32_bluetooth_Blocks
const esp32_bluetooth_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/bluetooth_extension.svg';
    return `
    <category name="Bluetooth" id="esp32_bluetooth_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_bluetooth_start" colour="#9B59B6">
            <value name="display_name">
                <shadow type="text">
                    <field name="TEXT">ESP32S3-BLE</field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
}

// esp32_soil_moisture_Blocks
const esp32_soil_moisture_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/ground.svg';
    return `
    <category name="Cảm biến độ ẩm đất" id="esp32_soil_moisture_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_soil_moisture_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_soil_moisture_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

// esp32_temperature_Blocks
const esp32_temperature_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/temperature.svg';
    return `
    <category name="Cảm biến nhiệt độ vật thể" id="esp32_temperature_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_temperature_artical_start" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_temperature_artical_value" colour="#9B59B6"/>
        ${categorySeparator}
    </category>
    `;
}

// esp32_light_sensor_Blocks
const esp32_light_sensor_Blocks = function (isInitialSetup, isStage, targetId) {
    const IconPath = 'static/assets/Cambienanhsang.svg';
    return `
    <category name="Cảm biến ánh sáng" id="esp32_light_sensor_blocks" colour="#FF8C00" secondaryColour="#E67E00" iconURI="${IconPath}">
        <block type="esp32_light_sensor" colour="#9B59B6"/>
        ${blockSeparator}
        <block type="esp32_light_sensor_value" colour="#9B59B6"/>
        ${blockSeparator}
        ${categorySeparator}
    </category>
    `;
}

/* eslint-enable no-unused-vars */

const xmlOpen = '<xml style="display: none">';
const xmlClose = '</xml>';

/**
 * @param {!boolean} isInitialSetup - Whether the toolbox is for initial setup. If the mode is "initial setup",
 * blocks with localized default parameters (e.g. ask and wait) should not be loaded. (LLK/scratch-gui#5445)
 * @param {?object} device - Full data of current selected deivce.
 * @param {?boolean} isStage - Whether the toolbox is for a stage-type target. This is always set to true
 * when isInitialSetup is true.
 * @param {?string} targetId - The current editing target
 * @param {?Array.<object>} categoriesXML - optional array of `{id,xml}` for categories. This can include both core
 * and other extensions: core extensions will be placed in the normal Scratch order; others will go at the bottom.
 * @property {string} id - the extension / category ID.
 * @property {string} xml - the `<category>...</category>` XML for this extension / category.
 * @param {?boolean} isRealtimeMode - Current program mode.
 * @param {?string} costumeName - The name of the default selected costume dropdown.
 * @param {?string} backdropName - The name of the default selected backdrop dropdown.
 * @param {?string} soundName -  The name of the default selected sound dropdown.
 * @returns {string} - a ScratchBlocks-style XML document for the contents of the toolbox.
 */
const makeToolboxXML = function (isInitialSetup, device = null, isStage = true, targetId, categoriesXML = [],
    isRealtimeMode = true,
    costumeName = '', backdropName = '', soundName = '') {
    isStage = isInitialSetup || isStage;
    const gap = [categorySeparator];

    costumeName = xmlEscape(costumeName);
    backdropName = xmlEscape(backdropName);
    soundName = xmlEscape(soundName);
    categoriesXML = categoriesXML.slice();
    const moveCategory = categoryId => {
        const index = categoriesXML.findIndex(categoryInfo => categoryInfo.id === categoryId);
        if (index >= 0) {
            // remove the category from categoriesXML and return its XML
            const [categoryInfo] = categoriesXML.splice(index, 1);
            return categoryInfo.xml;
        }
        // return `undefined`
    };

    const everything = [];

    const motionXML = moveCategory('motion') || motion(isInitialSetup, isStage, targetId);
    const looksXML = moveCategory('looks') || looks(isInitialSetup, isStage, targetId, costumeName, backdropName);
    const soundXML = moveCategory('sound') || sound(isInitialSetup, isStage, targetId, soundName);
    let eventsXML = moveCategory('event') || events(isInitialSetup, isStage, targetId);
    const controlXML = moveCategory('control') || control(isInitialSetup, isStage, targetId, isRealtimeMode);
    const sensingXML = moveCategory('sensing') || sensing(isInitialSetup, isStage, targetId);
    const operatorsXML = moveCategory('operators') || operators(isInitialSetup, isStage, targetId);
    const variablesXML = moveCategory('data') || variables(isInitialSetup, isStage, targetId);
    const myBlocksXML = moveCategory('procedures') || myBlocks(isInitialSetup, isStage, targetId);
    // const demoXML = moveCategory('demo') || demo(isInitialSetup, isStage, targetId);
    const manHinhXML = moveCategory('man_hinh') || manHinh(isInitialSetup, isStage, targetId);
    const dongcoXML = moveCategory('dong_co') || Dongco(isInitialSetup, isStage, targetId);
    // const cambienrungXML = moveCategory('cam_bien_rung') || Cambienrung(isInitialSetup, isStage, targetId);
    const cambienanhsangXML = moveCategory('cam_bien_anh_sang') || Cambienanhsang(isInitialSetup, isStage, targetId);
    // const cambienvatcanXML = moveCategory('cam_bien_vat_can') || Cambienvatcan(isInitialSetup, isStage, targetId);
    const cambienhongngoaiXML = moveCategory('cam_bien_hong_ngoai') || Cambienhongngoai(isInitialSetup, isStage, targetId);
    const nutnhanXML = moveCategory('nut_nhan') || Nutnhan(isInitialSetup, isStage, targetId);
    // const coichipXML = moveCategory('coi_chip') || Coichip(isInitialSetup, isStage, targetId);
    // const bluetoothXML = moveCategory('bluetooth') || Bluetooth(isInitialSetup, isStage, targetId);
    // const duanmauXML = moveCategory('duan_mau') || Duanmau(isInitialSetup, isStage, targetId);
    const ledXML = moveCategory('led') || led(isInitialSetup, isStage, targetId);
    const timerXML = moveCategory('thoi_gian') || Thoigian(isInitialSetup, isStage, targetId);
    const passwordXML = moveCategory('mat_khau') || Matkhau(isInitialSetup, isStage, targetId);
    const esp32_test_block = moveCategory('esp32_test_blocks') || Esp32_Test_Blocks(isInitialSetup, isStage, targetId);
    const esp32_rgb_sensor_blocks = moveCategory('esp32_rgb_sensor_blocks') || Esp32_RGB_Sensor_Blocks(isInitialSetup, isStage, targetId);
    const esp32_motion_sensor_blocks = moveCategory('esp32_motion_sensor_blocks') || Esp32_Motion_Sensor_Blocks(isInitialSetup, isStage, targetId);
    const esp32_vl6180x_sensor_blocks = moveCategory('esp32_vl6180x_sensor_blocks') || Esp32_VL6180X_Sensor_Blocks(isInitialSetup, isStage, targetId);
    const esp32_tcrt5000_sensor_blocks = moveCategory('esp32_tcrt5000_sensor_blocks') || Esp32_TCRT5000_Sensor_Blocks(isInitialSetup, isStage, targetId);
    const esp32_hw484_sensor_blocks = moveCategory('esp32_hw484_sensor_blocks') || Esp32_HW484_Sensor_Blocks(isInitialSetup, isStage, targetId);
    const esp32_MQ2_Smoke_blocks = moveCategory('esp32_mq2_smoke_sensor_blocks') || Esp32_MQ2_Smoke_Blocks(isInitialSetup, isStage, targetId);
    const esp32_BME680_blocks = moveCategory('esp32_bme680_sensor_blocks') || Esp32_BME680_Blocks(isInitialSetup, isStage, targetId);
    const esp32_WB2812_led_blocks = moveCategory('esp32_wb2812_led_blocks') || Esp32_WB2812_Blocks(isInitialSetup, isStage, targetId);
    const esp32_Oled_blocks = moveCategory('esp32_oled_blocks') || Esp32_Oled_Blocks(isInitialSetup, isStage, targetId);
    const esp_servo_blocks = moveCategory('esp32_servo_blocks') || Esp32_Servo_Blocks(isInitialSetup, isStage, targetId);
    const esp32_motor_blocks = moveCategory('esp32_motor_blocks') || Esp32_Motor_Blocks(isInitialSetup, isStage, targetId);
    const esp32_button_blocks = moveCategory('nut_nhan') || Esp32_Button_Blocks(isInitialSetup, isStage, targetId);
    const esp32_led = moveCategory('led') || Esp32_Led(isInitialSetup, isStage, targetId);
    const esp32_wifi_blocks = moveCategory('esp32_wifi_blocks') || esp32_Wifi_Blocks(isInitialSetup, isStage, targetId);
    const esp32_bluetooth_block = moveCategory('esp32_bluetooth_blocks') || esp32_bluetooth_Blocks(isInitialSetup, isStage, targetId);
    const esp32_soil_moisture_blocks = moveCategory('esp32_soil_moisture_blocks') || esp32_soil_moisture_Blocks(isInitialSetup, isStage, targetId);
    const esp32_temperature_blocks = moveCategory('esp32_temperature_blocks') || esp32_temperature_Blocks(isInitialSetup, isStage, targetId);
    const esp32_light_sensor_blocks = moveCategory('esp32_light_sensor_blocks') || esp32_light_sensor_Blocks(isInitialSetup, isStage, targetId);
    if (device && !isRealtimeMode) {
        eventsXML = `
        <category name="Sự kiện" id="events" colour="#FFD500" secondaryColour="#CC9900">
            ${eventBlock[device.type]}
            ${categorySeparator}
        </category>
    `;
        if(device.deviceId !== 'arduinoEsp32S3') {
            everything.push(
                xmlOpen,
                eventsXML, gap,
                controlXML, gap,
                operatorsXML, gap,
                variablesXML, gap,
                myBlocksXML, gap,
                // demoXML, gap,
                manHinhXML,
                dongcoXML,
                // cambienrungXML, gap,
                cambienanhsangXML,
                // cambienvatcanXML, gap,
                cambienhongngoaiXML,
                passwordXML,
                nutnhanXML,
                // coichipXML,
                // bluetoothXML, gap,
                // duanmauXML,
                ledXML,
                timerXML
                // xmlClose
            );
        } else {
            everything.push(
                xmlOpen,
                eventsXML, gap,
                controlXML, gap,
                operatorsXML, gap,
                variablesXML, gap,
                myBlocksXML, gap,
                esp32_test_block, gap,
                esp32_rgb_sensor_blocks, gap,
                esp32_motion_sensor_blocks, gap,
                esp32_vl6180x_sensor_blocks, gap,
                esp32_tcrt5000_sensor_blocks, gap,
                esp32_hw484_sensor_blocks, gap,
                esp32_MQ2_Smoke_blocks, gap,
                esp32_BME680_blocks, gap,
                esp32_WB2812_led_blocks, gap,
                esp32_Oled_blocks, gap,
                esp_servo_blocks, gap,
                esp32_motor_blocks, gap,
                esp32_button_blocks, gap,
                esp32_led, gap, 
                esp32_wifi_blocks, gap,
                esp32_bluetooth_block, gap,
                esp32_soil_moisture_blocks, gap,
                esp32_temperature_blocks, gap,
                esp32_light_sensor_blocks
                // xmlClose
            );
        }
    } else {
        everything.push(
            xmlOpen,
            motionXML, gap,
            looksXML, gap,
            soundXML, gap,
            eventsXML, gap,
            controlXML, gap,
            sensingXML, gap,
            operatorsXML, gap,
            variablesXML, gap,
            myBlocksXML, gap,
            // xmlClose
        );
    }

    for (const extensionCategory of categoriesXML) {
        everything.push(gap, extensionCategory.xml);
    }

    everything.push(xmlClose);
    return everything.join('\n');
};

export default makeToolboxXML;
